/* eslint-disable react/no-array-index-key */
import React, { PureComponent } from 'react';
import { Collapse } from 'reactstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import ChatIcon from 'mdi-react/ChatIcon';
import ChatPlusIcon from 'mdi-react/ChatPlusIcon';
import ChatTypingIcon from 'mdi-react/ChatTypingIcon';
import { findAllChatByUserNotReadTopbar, markAsReceived } from "../../Services/ChatService";
import { useBasicAuth } from '../../../shared/components/auth/withBasicAuth';
import { environment } from '../../environment';
import { util } from "../../../shared/util";


// let img = `${process.env.PUBLIC_URL}/img/topbar/coffee_`;

class TopbarChat extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      showAlert: false,
      showAlertOK: true,
      intervalId: 0,
      notification: [],
      chats: []
    };

    this.markAllAsReceived = this.markAllAsReceived.bind(this);
  }

  toggle = () => {
    this.setState(prevState => ({ collapse: !prevState.collapse }));
  };

  load(){
    if(useBasicAuth.checkTokenExists()){
      let user = environment.getUser();
      this.loadMessagens(user);
    }else{
      clearInterval(this.state.intervalId);
    }
  }

  init(){
    const loadBounded = this.load.bind(this);
    if(this.state.intervalId === 0){
      let intervalId = setInterval(loadBounded, 30000);
      this.setState({intervalId: intervalId}, () => {
        useBasicAuth.addInterval("MENU_CHAT_VIEW_TOPBAR", intervalId);
        this.load();
      });
    }
  }

  buildNotifications(data){
    console.log("buildNotifications");
    console.log(data);
    let notification = [];
    let chats = [];
    let showAlert = false;
    let showAlertOK = false;
    let total = 0;

    total = data.length;
    if(total > 0){
      for(let i = 0; i < total; i++){
        showAlert = true;
        let contact = data[i];
        let lastMessage = contact.messages.slice(-1)[0];

        console.log(contact);
        
        let item = {
          ava: contact.avatar,
          name: lastMessage.name,
          userName: lastMessage.userName,
          message: (lastMessage.message.length > 60 ? lastMessage.message.substring(0,60) + "..." : lastMessage.message),
          code: contact.post,
          date: util.formatDateHoraToString(lastMessage.createdAt, ""),
          color: "#e7f3fd",
        }
        if(notification.length < 5){
          notification.push(item);
        }
        chats.push(contact);
      
      }
    }else{
      showAlertOK = true;
    }
    if(showAlert && this.state.showAlertOK){
      this.props.show('danger', this.props.t('chats.dangerTitle'), this.props.t('chats.dangerMessage'), '');
      this.setState({ notification, chats, showAlert, showAlertOK });
    }else{
      this.setState({ notification, chats, showAlert, showAlertOK });
    }
    
  }

  markAllAsReceived = () => {
    // const total = this.state.chats.length;
    // let order = {}
    // for(let i = 0; i < total; i++){
    //   order = this.state.chats[i];
    //   order.status = "RECEIVED";
    //   updateOrder(order)
    //   .then(obj => {
    //     if((i+1) === total){
    //       this.load();
    //     }
    //   });
    // }
    // this.setState({ showAlert: false, showAlertOK: true });
  }

  handleSubmit(contact) {
    useBasicAuth.redirectChat(contact);
  }

  setAvatar(obj){
    if(obj.avatar === null || obj.avatar === undefined || obj.avatar === ''){
      obj.avatar = `${process.env.PUBLIC_URL}/img/12.png`
    }
  }

  loadMessagens(user){
    findAllChatByUserNotReadTopbar(user.id)
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        if(data.chatListTopbar !== null && data.chatListTopbar !== undefined && data.chatListTopbar.length > 0){
          let msgsTopbar = [];//myContacts;
          for(let i = 0; i < data.chatListTopbar.length; i++){
            this.setAvatar(data.chatListTopbar[i]);
            msgsTopbar.push(data.chatListTopbar[i]);            
          }
          this.buildNotifications(msgsTopbar);

          if(msgsTopbar.length > 0){
            markAsReceived(user.id).then(data => {});
          }
        }else{
          this.setState({ notification: [], chats: [], showAlert: false, showAlertOK: true });
        }
      } else {
        console.log("error loadMessagens:");
        console.log(data);
      }
    });
  }

  componentDidMount() {
    this.init();
  }

  render() {
    const { collapse } = this.state;
    const { t } = this.props;

    // MCCOSTA: Chat
    
    let ico = <ChatIcon />;
    let iconAlert = "";
    if(this.state.showAlert){
      iconAlert = <div className="topbar__btn-new-label"><div /></div>
      // ico = <ChatPlusIcon />;
    }
    //<ChatTypingIcon />

    return (
      <div className="topbar__collapse">
        <style>
          {`
            .hover-div {
              background: #FFFFFF;
            }

            .hover-div:hover {
              background: #F8F8F8;
            }

            .topbar__collapse-name {
              color: #009021;
            }

            .topbar__collapse-link {
              color: #009021;
            }
          `}
        </style>
        <button className="topbar__btn topbar__btn--mail topbar__btn--new" type="button" onClick={this.toggle}>
          {ico}
          {iconAlert}
        </button>
        {collapse && <button className="topbar__back" type="button" onClick={this.toggle} />}
        <Collapse
          isOpen={collapse}
          className="topbar__collapse-content topbar__collapse-content--notify"
        >
          <div className="topbar__collapse-title-wrap">
            <p className="topbar__collapse-title">{t('chats.title')}</p>
            {/* <button className="topbar__collapse-button" type="button" onClick={this.markAllAsReceived}>
              {t('chats.markAllAsReceived')}
            </button> */}
          </div>
          {this.state.notification.map((chat, index) => (
            <div className="topbar__collapse-item hover-div" key={index} 
              onClick={() => this.handleSubmit(chat.userName)}
              style={{cursor: "pointer", backgroundColor: chat.color !== null ? chat.color : null }}>
              <div className="topbar__collapse-img-wrap">
                <img className="topbar__collapse-img" src={chat.ava} alt="" />
              </div>
              <p className="topbar__collapse-message">
                <span className="topbar__collapse-name">{chat.name}</span>
                <br />
                {chat.message}
              </p>
              <p className="topbar__collapse-date">{chat.date}</p>
            </div>
          ))}
          <Link className="topbar__collapse-link" to="/forms/chat" onClick={this.toggle}>
            {t('chats.seeAllOrders')}
          </Link>
        </Collapse>
      </div>
    );
  }
}

export default withTranslation('common')(TopbarChat);